import { render } from "./fullscreen-v1.vue?vue&type=template&id=1adfd9c8&scoped=true"
import script from "./fullscreen-v1.vue?vue&type=script&lang=js"
export * from "./fullscreen-v1.vue?vue&type=script&lang=js"

import "./fullscreen-v1.vue?vue&type=style&index=0&id=1adfd9c8&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adfd9c8"]])

export default __exports__